import React from 'react';
import TextScale from 'packages/pages/editor/RightSideMenu/Shots/Text/TextScale';
import { SCALE_PROPS, TextScaleProps } from 'packages/pages/editor/RightSideMenu/Shots/Text/TextScale/types';

export const FontScale = (props: TextScaleProps) => <TextScale {...props} propName={SCALE_PROPS.FONT_SCALE} />;

export default FontScale;
